/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_Workout_Body_WebInputs */

const en_us2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version has been downloaded. Since a workout is in progress, it opens when you reload the app after the workout.`)
};

const pt_br2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma versão nova já foi baixada. Como há um treino em andamento, ela abre quando você recarregar o app depois do treino.`)
};

const es_419_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se descargó una versión nueva. Como hay un entrenamiento en curso, se abrirá cuando recargues la app después del entrenamiento.`)
};

const pt_pt2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já foi transferida uma versão nova. Como há um treino a decorrer, abre quando recarregares a app depois do treino.`)
};

const fr_fr2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une nouvelle version a été téléchargée. Comme une séance est en cours, elle s'ouvrira quand tu rechargeras l'app après la séance.`)
};

const de_de2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Version wurde heruntergeladen. Da ein Training läuft, öffnet sie sich, wenn du die App nach dem Training neu lädst.`)
};

const it_it2_profile_update_workout_body_web = /** @type {(inputs: Profile_Update_Workout_Body_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È stata scaricata una nuova versione. Dato che c'è un allenamento in corso, si aprirà quando ricarichi l'app dopo l'allenamento.`)
};

/**
* | output |
* | --- |
* | "A new version has been downloaded. Since a workout is in progress, it opens when you reload the app after the workout." |
*
* @param {Profile_Update_Workout_Body_WebInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_workout_body_web = /** @type {((inputs?: Profile_Update_Workout_Body_WebInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Workout_Body_WebInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_workout_body_web(inputs)
	if (locale === "es-419") return es_419_profile_update_workout_body_web(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_workout_body_web(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_workout_body_web(inputs)
	if (locale === "de-DE") return de_de2_profile_update_workout_body_web(inputs)
	if (locale === "it-IT") return it_it2_profile_update_workout_body_web(inputs)
	return en_us2_profile_update_workout_body_web(inputs)
});
export { profile_update_workout_body_web as "profile.update_workout_body_web" }